import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './VoiceRecorder.module.scss';
import PropTypes from 'prop-types';
import SVGCharacters from 'icons/Components/SVGCharacters';
import { RecordingAnimation } from 'components/AudioRecAndPlay/RecordingAnimation';
import { playMultipleSounds } from 'utils/play-multiple-sounds';
import { showVisualCue, hideVisualCue } from 'store/actions/ui';

const RECORDING_INTERVAL = 4000;

export class WordRepeater extends Component {
  constructor(props) {
    super(props);
    this.state = {
      round: 1,
      showRecorder: false,
      done: false
    };

    this.timers = [];
  }

  async round(idx) {
    const {
      currentRound: {
        audio,
        data: { instructions, affirmations, repeats }
      },
      onRoundEnd
    } = this.props;

    if (idx > repeats) {
      this.setState({ done: true });
      onRoundEnd();
      return;
    }

    const instructionsToPlay =
      idx === 1 ? instructions.beforeRepeating : instructions.beforeRerepeating;

    this.promise = playMultipleSounds(500, audio, instructions.introduction)
      .then(() => playMultipleSounds(500, audio, instructionsToPlay))
      .then(() => this.setState({ showRecorder: true }))
      .then(() => this.playAudioCue('start'))
      .then(() => {
        let counter = 1;
        return new Promise(resolve => {
          const interval = setInterval(() => {
            if (counter < Math.floor(RECORDING_INTERVAL / 1000)) {
              counter++;
              this.playAudioCue('mid');
            } else {
              clearInterval(interval);
              resolve();
            }
          }, 1000);
        });
      })
      .then(() => this.playAudioCue('end'))
      .then(() => this.addVisualCue('success'))
      .then(() => this.setState({ showRecorder: false }))
      .then(() => playMultipleSounds(500, audio, affirmations[idx - 1]))
      .then(() => this.round(idx + 1));
  }

  componentDidMount() {
    this.round(1);
  }

  componentWillUnmount() {
    this.timers.forEach(tID => clearTimeout(tID));
    this.props.currentRound.stopAllSounds();
    this.promise && this.promise.cancel();
  }

  addVisualCue(message, interval = 1000) {
    this.props.showVisualCue(message);
    this.timers.push(setTimeout(() => this.props.hideVisualCue(), interval));
  }

  playAudioCue(type) {
    const { commonSounds } = this.props;
    if (type === 'start') {
      commonSounds.clickStart && commonSounds.clickStart.play();
    } else if (type === 'mid') {
      commonSounds.beep && commonSounds.beep.play();
    } else if (type === 'end') {
      commonSounds.clickEnd && commonSounds.clickEnd.play();
    }
  }

  render() {
    const {
      props: {
        currentRound: {
          data: { number, word, image }
        }
      },
      state: { showRecorder }
    } = this;

    const NumberSVG = SVGCharacters[number];

    return (
      <div className={styles.SoundRecorder}>
        <div className={styles.Image} id="image-repeater">
          {NumberSVG && <NumberSVG />}
          {word && <h3>{word}</h3>}
          {image && <img src={image.src} alt={image.description} />}
        </div>
        <div className={styles.Instructions} />
        <div className={styles.Recorder}>
          {showRecorder && <RecordingAnimation isActive={true} />}
        </div>
      </div>
    );
  }
}

WordRepeater.propTypes = {
  currentRound: PropTypes.object,
  onRoundEnd: PropTypes.func,
  isVideoModalOpen: PropTypes.bool,
  showVisualCue: PropTypes.func,
  hideVisualCue: PropTypes.func,
  commonSounds: PropTypes.object
};

const mapStateToProps = state => ({
  isVideoModalOpen: state.activity.isVideoModalOpen,
  commonSounds: state.ui.sounds.common
});

const mapDispatchToProps = {
  showVisualCue,
  hideVisualCue
};

export default connect(mapStateToProps, mapDispatchToProps)(WordRepeater);
